export default __webpack_public_path__ + "static/media/serviceTypeImg2.ee0b1e69.svg";